import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlBuilderService } from 'projects/communication/src/app/services/url-builder.service';
import { CacheService } from 'projects/common/src/app/services/cache.service';
import { IOutputFilter } from '../../core/interfaces/output-filter';
import { Logger } from 'projects/common/src/app/classes/logger';
import { CommunicationService } from 'src/app/services/communication';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ReportZoneHistoryService extends Logger {
  private baseUrl: string;

  constructor(
    private http: HttpClient,
    private cacheService: CacheService,
    private communicationService: CommunicationService,
    private parameterService: ParameterHandlerService,
    private urlBuilder: UrlBuilderService,
  ) {
    super();
    this.baseUrl = this.urlBuilder.serverBasePath;
  }

  /**
   *  Function to check if there it is data
   */

  public getZoneHistoryData(selectedFilters: IOutputFilter) {
    const params = this.setParams(selectedFilters);
    const url = `${this.baseUrl}/Report/GetZoneHistoryReport`;
    return this.communicationService.get(url, params).toPromise();
  }

  /**
   * Function to get report excel
   */
  public getZoneHistoryReportExcel(selectedFilters: IOutputFilter): Observable<any> {
    const params = this.setParams(selectedFilters);
    const url = `${this.urlBuilder.apiUrl}/Report/GetZoneHistoryReportDocument`;
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((error) => throwError(() => error.error)));
  }

  /**
   * Function to set params and send selected filters to request
   *
   * @param selectedFilters Filters selected to save params
   */
  public setParams(selectedFilters: IOutputFilter): any {
    return {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
    };
  }

  public getZoneHistory(params: any): Observable<any> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetZoneHistory`;
    return this.http.get(url, { params }).pipe(catchError((error) => throwError(() => error.error)));
  }
}
